var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29v-2a4 4 0 014-4h7a4 4 0 014 4v2M19.5 15a4 4 0 108 0 4 4 0 00-8 0zM9.857 20H15m0 0v-5.143M15 20l-6-6",
    stroke: "#476FF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNFREYxRkYiLz4KPHBhdGggZD0iTTE2IDI5VjI3QzE2IDI1LjkzOTEgMTYuNDIxNCAyNC45MjE3IDE3LjE3MTYgMjQuMTcxNkMxNy45MjE3IDIzLjQyMTQgMTguOTM5MSAyMyAyMCAyM0gyN0MyOC4wNjA5IDIzIDI5LjA3ODMgMjMuNDIxNCAyOS44Mjg0IDI0LjE3MTZDMzAuNTc4NiAyNC45MjE3IDMxIDI1LjkzOTEgMzEgMjdWMjlNMTkuNSAxNUMxOS41IDE3LjIwOTEgMjEuMjkwOSAxOSAyMy41IDE5QzI1LjcwOTEgMTkgMjcuNSAxNy4yMDkxIDI3LjUgMTVDMjcuNSAxMi43OTA5IDI1LjcwOTEgMTEgMjMuNSAxMUMyMS4yOTA5IDExIDE5LjUgMTIuNzkwOSAxOS41IDE1WiIgc3Ryb2tlPSIjNDc2RkYyIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOS44NTcxNCAyMEwxNSAyME0xNSAyMEwxNSAxNC44NTcxTTE1IDIwTDkgMTQiIHN0cm9rZT0iIzQ3NkZGMiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgResourceNew as ReactComponent };